<template>
  <div class="dfAgreement">
      <!-- <div class="title">用户协议</div> -->
      <div class="detail">
          <div class="name">
            特别提示
          </div>
          <div class="txt">
            为了维护您的利益，请您认真阅读本协议以下各条款，充分了解您的权利及义务。您阅读并同意本协议后，即表示您已对所有条款的含义及相应的法律后果全部通晓并充分理解，且自愿作出下述授权、承诺和声明。其中，授权包含《征信业管理条例》中征信业务，您应对于《征信业管理条例》及相关法律法规有一定的了解，如您不能清楚地知晓或理解国家相关法律法规规定的内容，您应咨询相关法律专业人士后再决定是否接受本协议。
          </div>
          <div class="txt">
            武汉大方汽车租赁有限公司（以下简称"大方租车"）同意按照本协议的规定及其不时发布的操作规则提供基于互联网的相关服务（以下称"网络服务"），为获得网络服务，服务使用人（以下称"用户"）应当同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户注册成功即表示用户完全接受本协议项下的全部条款。
          </div>
          <div class="name">
            1.会员权利与义务
          </div>
          <div class="txt">
            用户注册成功后，大方租车将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户自行保管。任何该账户项下的预订及支付等行为均视为该用户本人的操作。会员资格仅限会员本人使用。
          </div>
          <div class="txt">
            1.1 会员权利
          </div>
          <div class="txt">
            会员享有使用大方租车产品和服务的权益。
          </div>
          <div class="txt">
            1.2 会员义务
          </div>
          <div class="txt">
            1.2.1 会员租车时需遵守大方租车的产品和服务规定；
          </div>
          <div class="txt">
            1.2.2 会员的资料发生变更（如工作变动、住址迁移、联系方式变动或单位名称变更、单位迁址等信息等）时，应及时通知大方租车；
          </div>
          <div class="txt">
            1.2.3 会员授权并同意大方租车存储及使用会员所提交的个人信息（使用用途为会员与大方租车之间的汽车租赁相关业务，包括但不限于大方租车车可以以短信、电子邮箱等形式向会员发送商业信息），并授权大方租车可能为提供服务及提升服务质量的目的，从商业合作伙伴处获取信息作为补充。大方租车承诺仅在上述用途中使用获取的补充信息。
          </div>
          <div class="txt">
            1.3.会员待遇
          </div>
          <div class="txt">
            消费积分：凡在大方租车购买租车自驾服务，所消费的车辆租金和增值服务金额均可折算成积分计入个人账户。活动赠送积分：活动赠送、问卷调查等赠送的积分；活动赠送不定期举办，活动形式包括但不限于注册用户奖励、线上预订预付奖励、与第三方合作推广活动奖励等。
          </div>
          <div class="name">
            2. 服务内容
          </div>
          <div class="txt">
            通过大方租车网站在线预订车辆、查询价格车型信息、对提供的服务发表意见等。（具体查看公司网页http://www.dafang24.com/）
          </div>
          <div class="txt">
            2.1 服务变更、中断或终止
          </div>
          <div class="txt">
            2.2 鉴于网络服务的特殊性，用户授权大方租车可随时变更、中断或终止部分或全部的网络服务。由于大方租车需要定期或不定期地对提供网络服务的平台（如互联网网站）或相关的设备进行检修或者维护，如因此类情况而造成网络服务在合理时间内的中断，大方租车无需为此承担任何责任。
          </div>
          <div class="txt">
            2.3 如发生下列任何一种情形，大方租车有权在通知用户后中断或终止向用户提供本协议项下的网络服务而无需对用户或任何第三方承担任何责任：
          </div>
          <div class="txt">
            2.3.1 用户提供的个人资料不真实；
          </div>
          <div class="txt">
            2.3.2 用户违反本协议中规定的使用规则；
          </div>
          <div class="txt">
            2.3.3 如用户注册的帐号在任何连续180日内未实际使用，则大方租车有权删除该帐号并停止为该用户提供相关的网络服务。
          </div>

          <div class="name">
            3．使用规则
          </div>
          <div class="txt">
            3.1 用户在申请使用大方租车网络服务时，必须向大方租车提供准确真实的个人资料，如个人资料有任何变动，必须在三个工作日内更新。
          </div>
          <div class="txt">
            3.2 用户需妥善保管其个人账号密码，无论基于何种相关目的，都不允许将帐号、密码转让或出借于他人使用。如用户发现其帐号遭他人非法使用，应当立即通知大方租车。因黑客行为、用户的保管疏忽导致帐号、密码遭他人非法使用或用户将其帐号、密码转让或出借于他人使用而导致任何的客户损失，大方租车不承担任何责任。
          </div>
          <div class="txt">
            3.3 用户注册成功后，视为允许大方租车通过电子邮件或其他方式向用户发送大方租车的优惠服务信息。
          </div>
          <div class="txt">
            3.4 用户在使用大方租车网络服务过程中，必须遵循以下原则：
          </div>
          <div class="txt">
            3.4.1 遵守中国有关的法律和法规；
          </div>
          <div class="txt">
            3.4.2 遵守所有与网络服务有关的网络协议、规定和程序；
          </div>
          <div class="txt">
            3.4.3 不得为任何非法目的而使用网络服务系统；
          </div>
          <div class="txt">
            3.4.4 不得利用大方租车网络服务系统进行任何不利于大方租车的行为
          </div>

          <div class="name">
            4.知识产权
          </div>
          <div class="txt">
            大方租车提供的服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。大方租车为提供服务而使用的任何软件（包括但不限于软件中所含的任何图象、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，用户不得对该软件进行反向工程（reverse engineer）、反向编译（decompile）或反汇编（disassemble）。
          </div>

          <div class="name">
            5．隐私保护
          </div>

          <div class="txt">
            隐私权是您的重要权利。向我们提供您的个人信息是基于对我们的信任，相信我们会以负责的态度对待您的个人信息。我们认为您提供的信息只能用于帮助我们为您提供更好的服务。因此，我们制定了大方租车会员个人信息保密制度以保护您的个人信息。大方租车的个人信息保密制度如下：
          </div>
          <div class="txt">
            5.1 保密：
          </div>
          <div class="txt">
            通常，您能在匿名的状态下访问我们的网站并获取信息。在我们请求您提供有关信息之前，我们会解释这些信息的用途，我们有些站点需要注册才能加入。在通常情况下，这类注册要求您提供一个电子邮件地址和一些诸如您的工作、职务及所使用车辆等一类的基本信息，有时我们也会请您提供更多的信息。我们这样做是为了使我们更好的了解您的需求，以便向您提供更有效的服务。我们收集的信息包括姓名、性别、年龄、有效证件、地址、电话号码等。您有权随时决定不接受来自我们的任何资料。我们将采取合理的措施尽最大可能保护您的个人资料。每当您提供给我们信息时，我们将采取合理的措施保护您的个人资料，我们也将采取合理的安全手段保护已存储的个人资料。除非根据法律或政策的强制性规定，在未得到您的许可之前，我们不会把您的任何个人资料提供给无关的第三方。但是，如果您要求我们提供特定客户支援服务或把一些物品送交给您，我们则需要把您的姓名和地址提供给第三者。
          </div>
          <div class="txt">
            5.2 隐私权原则：
          </div>
          <div class="txt">
            您一旦注册成功成为会员，将得到一个密码和帐号。如果您不保管好自己的帐号和密码安全，将负全部责任。另外，每个用户都要对其帐户中的所有活动和事件负全责。您可随时根据指示改变您的密码以及个人资料。由于您的隐私权对我们而言是相当重要的，因此，公布这份隐私权声明的大方租车会根据下列五项原则管理涉及隐私的信息。
          </div>
          <div class="txt">
            5.2.1 每当大方租车需要识别您的身份或与您联络时，会明确的询问所需的资料，即个人资料。一般而言，当您在网站上注册，要求提供特别服务，或是如参加积分奖励等，便会被询问到这项资料。可能的话，大方租车会利用一些方法，确认您的个人资料的正确性与时效性。
          </div>

          <div class="txt">
            5.2.2 如果想要将个人资料用在其他用途上，大方租车会提供您如何拒绝这项服务的说明。您可以依照大方租车的说明，拒绝这项服务。
          </div>
          <div class="txt">
            5.2.3大方租车也许会因法律要求公开个人资料，或者因善意确信这样的作法对于下列各项有其必要性：
          </div>
          <div class="txt">
            （1）符合法律公告或遵守适用于大方租车站点的合法程序；
          </div>
          <div class="txt">
            （2）保护大方租车的用户权利或财产；
          </div>
          <div class="txt">
            （3）在紧急的情况下，为了保护大方租车及他们的用户或会员之个人或公众安全。

          </div>
          <div class="txt">
            5.2.4 任何时候如果您认为www.dafang24.com没有遵守这些原则时，请利用电子邮件4006668818 通知我们，我们会尽一切努力，在合理适当的范围内立即改善这个问题。
          </div>

          <div class="txt">
            5.2.5 Cookies的用途
          </div>
          <div class="txt">
            大方租车有时会使用cookies，使您在访问我们的网站时得到更好的服务。Cookies是指一种技术，当使用者访问设有Cookies装置的本网站时，本网站的服务器会自动发送Cookies至阁下浏览器内，并储存到您的电脑硬盘内，此Cookies便负责记录日后您访问本网站的各种活动、个人资料、浏览习惯、消费习惯甚至信用记录。运用Cookies技术，本网站能够为您提供更加周到的个性化服务。大方租车使用 Cookie 来帮助您实现您的联机体验的个性化。因此，Cookie的主要用途之一是提供一种节约时间的实用功能。您可以接受或拒绝Cookie。大多数Web浏览器会自动接受Cookie，但您通常可根据自己的需要来修改浏览器的设置以拒绝 Cookie。
          </div>
          <div class="txt">
            5.2.6 大方租车有权使用通过合法途径获得的用户其他身份信息（如身份证照片等）用于为用户提供服务，该信息是依据用户提供的身份信息而合法获取的，且仅限用于为客户提供服务。
          </div>

          <div class="name">
            6．免责声明
          </div>
          <div class="txt">
            6.1 用户明确同意其使用大方租车网络服务所存在的风险将完全由其自己承担；因其使用大方租车网络服务而产生的一切后果也由其自己承担，大方租车对用户不承担任何责任。
          </div>
          <div class="txt">
            6.2 大方租车不保证为向用户提供便利而设置的外部链接的准确性和完整性。同时，对于该等外部链接指向的不由大方租车实际控制的任何网页上的内容，大方租车不承担任何责任。
          </div>
          <div class="txt">
            6.3 对于因不可抗力或非因大方租车的原因造成的网络服务中断或其它缺陷，大方租车不承担任何责任。
          </div>

          <div class="name">
            7．违约赔偿
          </div>
          <div class="txt">
            7.1 如因大方租车违反有关法律、法规或本协议项下的任何条款而给用户造成损失，大方租车同意承担由此造成的损害赔偿责任。
          </div>
          <div class="txt">
            7.2 用户同意保障和维护大方租车及其他用户的合法利益，如因用户违反有关法律、法规或本协议项下的任何条款而给大方租车或任何其他第三人造成损失，用户同意承担由此造成的一切损害赔偿责任。
          </div>
          <div class="name">
            8．协议修改
          </div>
          <div class="txt">
            8.1 大方租车有权随时修改本协议的任何条款，一旦本协议的内容发生变动，大方租车将会在http://www.dafang24.com网站上公布修改之后的协议内容，该公布行为视为大方租车已经通知用户修改内容。
          </div>
          <div class="txt">
            8.2 如果不同意大方租车对本协议相关条款所做的修改，用户有权停止使用网络服务。如果用户继续使用网络服务，则视为用户接受大方租车对本协议相关条款所做的修改
          </div>
          <div class="name">
            9．通知送达
          </div>
          <div class="txt">
            9.1 本协议项下大方租车对于用户所有的通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；大方租车可任意选择其中一种方式通知用户，该通知于发送之日视为已送达用户，用户知悉并接受通知之内容。
          </div>
          <div class="txt">
            9.2 用户如有任何事宜需通知大方租车，应当通过大方租车对外正式公布的通信地址、传真号码、电子邮件地址等联系方式进行联系及送达。
          </div>
          <div class="txt">
            10.为更好的享受大方租车提供的服务，本人知晓并同意芝麻信用有权基于提供征信服务的需要向合法保存有本人信息的机构采集本人信息（包括由大方租车有权将本人在使用其服务过程中提交或产生的信息提供给芝麻信用），用于验证本人信息的真实性及提供征信服务使用。本人授权芝麻信用，可根据大方租车的查询指令，向其提供相关信息的真实性判断结果及本人的信用信息，用以交易决策使用。
          </div>
          <div class="name">
            11．法律管辖
          </div>
          <div class="txt">
            如双方就本协议内容或其执行发生任何争议，双方应友好协商解决；协商不成时，任何一方均可向武汉大方汽车租赁有限公司所在地的人民法院提起诉讼。
          </div>
          <div class="name">
            12. 附则
          </div>
          <div class="txt">
            12.1 大方租车有权在任何时候更改大方租车会员服务计划的任何规定或终止当年会员服务计划，即使计划的修改或终止会影响会员积分累计或返还的权利，且不承担事先通知的义务。
          </div>
          <div class="txt">
            12.2 本章程由大方租车制定，大方租车拥有最终解释权。
          </div>
      </div>
  </div>
</template>
<script>
export default {
  name: "agreement",
  data() {
    return {
      isShow: false
    };
  },
  props: [],
  methods: {
    showCont() {
      this.isShow = true;
    },
    hideCont() {
      this.isShow = false;
    }
  }
};
</script>
<style lang="scss" scoped >
.dfAgreement {
    width:100%;
    display: flex;
    flex-direction: column;
    font-size: 24px;
    background-color: #fff;
    img {
      position: absolute;
      top: 15px;
      right: 15px;
      width: 40px;
      height: 40px;
      background-size: 100%;
    }
    .detail {
      padding: 20px 30px;
      // padding-top:70px;
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      color: gray;
      overflow: scroll;
      .name {
        margin-top: 20px;
        margin-bottom: 5px;
        font-weight: bold;
      }
      .txt {
        margin-bottom: 10px;
        line-height: 35px;
        text-align: justify;
      }
    }
}
</style>
